<div *ngIf="!!(notifications$ | async)?.length">
  <ccwb-notification-host [position]="position">
    <ccwb-notification
      class="cc-notification"
      *ngFor="let notification of notifications$ | async"
      [hideDismissButton]="!notification.dismissable"
      [icon]="notification.icon"
      [lifetime]="getNotificationLifetime(notification)"
      [variant]="notification.variant"
      (wbdismiss)="close(notification)"
    >
      <ng-container *ngIf="notification.content">
        <ng-container *ngTemplateOutlet="notification.content; context: notification.context || {}" />
      </ng-container>
      <ng-container *ngIf="notification.footer">
        <ng-container *ngTemplateOutlet="notification.footer; context: notification.context || {}" />
      </ng-container>
    </ccwb-notification>
  </ccwb-notification-host>
</div>

<ng-template #notificationContent let-renderContent="renderContent">
  <p [innerHtml]="renderContent | stripHtml | nl2br | bypassHtmlSecurity"></p>
</ng-template>
<ng-template #notificationFooter let-renderFooter="renderFooter">
  <p [innerHtml]="renderFooter | stripHtml | nl2br | bypassHtmlSecurity" slot="footer"></p>
</ng-template>
